import React from "react"
import { GENERIC_ERROR_CODES } from "./options.js"
import { pushGtmValues } from "@bappweb/utils";
import { DefaultDataLayerObject } from "./interfaces.js";

const hasValue = (value) => {
    if (value === null || value === undefined || value === "") {
        return false;
    } else {
        return true;
    }
};

export const tcknFormat = (message) => {
    return (value, props) => {
        const TCKN_FORMAT_MESSAGE = "TC kimlik numaranızı eksik veya yanlış girdiniz";
        if (hasValue(value)) {
            value = value.toString();

            const isEleven = /^[0-9]{11}$/.test(value);
            let totalX = 0;
            for (let i = 0; i < 10; i++) {
                totalX += Number(value.substr(i, 1));
            }
            let isRuleX = totalX % 10 == value.substr(10, 1);
            let totalY1 = 0;
            let totalY2 = 0;
            for (let i = 0; i < 10; i += 2) {
                totalY1 += Number(value.substr(i, 1));
            }
            for (let i = 1; i < 10; i += 2) {
                totalY2 += Number(value.substr(i, 1));
            }
            let isRuleY = ((totalY1 * 7) - totalY2) % 10 == value.substr(9, 0);

            if (!isEleven || !isRuleX || !isRuleY) {
                return React.createElement(
                    "div",
                    { className: "bapp-message" },
                    message || TCKN_FORMAT_MESSAGE
                );
            }
        }
    };
}

export const getUniqueEventId = () => {
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
        let item: DefaultDataLayerObject;

        item = window.dataLayer.find(
            (item) => item.event === "virtual_page_view"
        )

        let uniqueEventId;
        try {
            uniqueEventId = item["gtm.uniqueEventId"] ?? 0
        }
        catch {
            uniqueEventId = 0
        }

        return uniqueEventId
    }
    return 0
}

export const removeDataLayer = () => {
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
        window.dataLayer = window.dataLayer.filter(
            (item) => item.event !== "virtual_page_view"
        )
    }
}

export const pushDataLayer = (pageName: string, isFirstGtmValue: boolean, infoCode: string | null, isCustomerAndCardInfoScreen: boolean | null = null, isStep1: boolean | null = null) => {
    if (isFirstGtmValue) {
        pushGtmValues({
            event: "virtual_page_view",
            content_group: "kredi_karti",
            pageName: pageName,
            pageTitle: 'Bireysel Kredi Karti'
        })
        return
    }

    const uniqueEventId = getUniqueEventId()

    if (isCustomerAndCardInfoScreen) {
        if (isStep1) {
            removeDataLayer()
        }

        pushGtmValues({
            "event": "virtual_page_view",
            "content_group": "kredi_karti",
            "pageName": pageName,
            "pageTitle": 'Bireysel Kredi Karti',
            "gtm.uniqueEventId": uniqueEventId
        })
        return
    }

    removeDataLayer()

    if (hasValue(infoCode)) {
        pushGtmValues({
            "event": "virtual_page_view",
            "content_group": "kredi_karti",
            "pageName": pageName,
            "pageTitle": 'Bireysel Kredi Karti',
            "infoCode": infoCode,
            "gtm.uniqueEventId": uniqueEventId
        })
    } else {
        pushGtmValues({
            "event": "virtual_page_view",
            "content_group": "kredi_karti",
            "pageName": pageName,
            "pageTitle": 'Bireysel Kredi Karti',
            "gtm.uniqueEventId": uniqueEventId
        })
    }

}

export const setGenericErrorInfoCode = (errorCode: string) => {
    let infoCode = "";
    switch (errorCode) {
        case GENERIC_ERROR_CODES.TCKN_KPS_KAYDI_YOK:
            infoCode = "BGEN11";
            break;
        case GENERIC_ERROR_CODES.TCKN_APS_KAYIT_BULUNAMADI:
            infoCode = "BGEN12";
            break;
        case GENERIC_ERROR_CODES.MBB_CONTROL_ERROR_INVITE_TO_BRANCH:
            infoCode = "BGEN20";
            break;
        case GENERIC_ERROR_CODES.MBB_AST_DOGRULANAMADI:
            infoCode = "BGEN21";
            break;
        case GENERIC_ERROR_CODES.MBB_MUSTERI_TIPI_HATALI:
            infoCode = "BGEN22";
            break;
        case GENERIC_ERROR_CODES.EV_IS_TELEFONU_ALAN_KODU_HATALI:
            infoCode = "BGEN31";
            break;
        case GENERIC_ERROR_CODES.GUVENLI_TELEFONU_BULUNAMADI:
            infoCode = "BGEN23";
            break;
        case GENERIC_ERROR_CODES.TELEFON_BASKA_MUSTERIDE_AST_OLARAK_TANIMLI:
            infoCode = "BGEN24";
            break;
        default:
            infoCode = "BGEN0";
            break;
    }

    // pushDataLayer("/basvuru/kredi-karti/genericerror", false, infoCode)
    pushGtmValues({
        "event": "virtual_page_view",
        "content_group": "kredi_karti",
        "pageName": "/basvuru/kredi-karti/genericerror",
        "pageTitle": 'Bireysel Kredi Karti',
        "infoCode": infoCode
    })
}
export const showChatbot = () => {
    var event = new CustomEvent("CONVERSATIONAL_PLATFORM", { "detail": { "type": 'show', "action": { "functionCode": "FUNC06" } } });
    document.dispatchEvent(event);
}
export const hideChatbot = () => {
    var event = new CustomEvent("CONVERSATIONAL_PLATFORM", { "detail": { "type": 'hide' } });
    document.dispatchEvent(event);
}